import type { GridApi } from "~/components/grid/AgGrid";

import gridFilterFeedback from "~/helpers/grid/gridFilterFeedback";

const clearGridFilters = async (api: GridApi | undefined, colId?: string): Promise<void> => {
	if (!api || api.isDestroyed()) return;
	for (const [field, failure] of gridFilterFeedback.getGridFilterFeedback(api).failures) {
		if (colId === undefined || field === colId) failure.cancel();
	}
	if (colId === undefined) {
		api.setFilterModel(null);
	} else {
		await api.setColumnFilterModel(colId, null);
		if (!api.isDestroyed()) api.onFilterChanged();
	}
};

export default clearGridFilters;
